if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.popupIds = [];
        this.productUrl = '';
        
        this.addEventListener('click', (event) => {
          const sizeChart = this.querySelector('dialog.tsb-sizechart');
          if (!sizeChart) return;
          if (event.target.closest('[data-tsb-sizechart]')) {
            event.preventDefault();
            sizeChart.showModal();
          } else if (event.target.closest('[data-tsb-sizechart-close]') || event.target === sizeChart) {
            sizeChart.close();
          }
        });

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
                if (this.priceObserver) this.priceObserver.disconnect();

        // remove the size chart pop-ups that were moved to the page body
        this.popupIds.forEach((id) => {
          const dialog = document.getElementById(id);
          if (dialog) dialog.remove();
        });
        this.popupIds = [];

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        this.productUrl = opener.getAttribute('data-product-url');

        fetch(this.productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.modalContent.querySelector('product-component')?.dispatchViewEvent?.();

            this.addExtraButtons();
                        this.watchPrices();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.simplify(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        // keep the size chart pop-up, remove every other dialog
        const modalDialog = productElement.querySelectorAll('modal-dialog');
        modalDialog.forEach((modal) => {
          if (modal.classList.contains('product-popup-modal')) {
            if (modal.id && this.popupIds.indexOf(modal.id) === -1) this.popupIds.push(modal.id);
          } else {
            modal.remove();
          }
        });
      }

      // Keep only: title, price, size chart, sizes, quantity, add to cart
      simplify(productElement) {
        productElement
          .querySelectorAll(
            '.tsb-pdp-crumbs, .product__care, .product-care, .product__media-wrapper, .product-wishlist, .product__inventory, .share-button, .product__view-details, .shopify-payment-button, [data-shopify="payment-button"], link[href*="product-remodel"], script[src*="product-remodel"]'
          )
          .forEach((el) => el.remove());

        const info = productElement.querySelector('.product__info-container');
        if (!info) return;

        const keep =
          '.product__title, [id^="price-"], .product-popup-modal__opener, variant-selects, .product-form__quantity, product-form, .product-form';
        Array.from(info.children).forEach((child) => {
          if (child.matches(keep) || child.querySelector(keep)) return;
          child.remove();
        });
      }

            // show prices without the "$" sign (keeps the USD text)
      watchPrices() {
        const clean = () => {
          this.modalContent.querySelectorAll('.price-item').forEach((el) => {
            if (el.textContent.indexOf('$') > -1) el.textContent = el.textContent.replace(/\$\s?/g, '');
          });
        };
        clean();
        if (this.priceObserver) this.priceObserver.disconnect();
        this.priceObserver = new MutationObserver(clean);
        this.priceObserver.observe(this.modalContent, { childList: true, subtree: true, characterData: true });
      }
      addExtraButtons() {
        const info = this.modalContent.querySelector('.product__info-container');
        if (!info || info.querySelector('.tsb-qa-extra')) return;

        const wrap = document.createElement('div');
        wrap.className = 'tsb-qa-extra';

        const buy = document.createElement('button');
        buy.type = 'button';
        buy.className = 'tsb-qa-buy';
        buy.textContent = 'Buy now';
        buy.addEventListener('click', () => this.buyNow(buy));

        const view = document.createElement('a');
        view.className = 'tsb-qa-view';
        view.href = this.productUrl;
        view.innerHTML =
          '<span>View full details</span><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="0" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';

        const error = document.createElement('p');
        error.className = 'tsb-qa-error';
        error.setAttribute('role', 'alert');

        wrap.appendChild(buy);
        wrap.appendChild(view);
        wrap.appendChild(error);
        info.appendChild(wrap);
      }

      buyNow(button) {
        const idInput = this.modalContent.querySelector('form input[name="id"]');
        const submit = this.modalContent.querySelector('.product-form__submit');
        const qtyInput = this.modalContent.querySelector('.quantity__input');
        const error = this.modalContent.querySelector('.tsb-qa-error');
                if (!idInput || (submit && submit.disabled)) return;
        if (error) error.textContent = '';

        const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        button.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(idInput.value), quantity: quantity })
        })
          .then((response) => response.json())
          .then((result) => {
            if (result.status) {
              if (error) error.textContent = result.description || result.message || 'This item could not be added.';
              button.disabled = false;
              return;
            }
            window.location.href = '/checkout';
          })
          .catch(() => {
            if (error) error.textContent = 'Something went wrong. Please try again.';
            button.disabled = false;
          });
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}